var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chart-container"},[_c('div',{staticClass:"body"},[_c('canvas',{attrs:{"id":_vm.idForChart}})]),_c('div',{staticClass:"footer"},_vm._l((_vm.data),function(legend){return _c('ChartLegend',{attrs:{"value":legend.value,"text":legend.label,"color":legend.color}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }